export default __webpack_public_path__ + "static/media/change-link-img.62f5ac39.svg";